import React from 'react';
import { string, node } from 'prop-types';
import classNames from 'classnames';

import './style.scss';

const Subtitle = ({ className, children }) => <p className={classNames('modal-subtitle', className)}>{children}</p>;

Subtitle.propTypes = {
    className: string,
    children: node,
};

export default Subtitle;
